module.exports = __webpack_public_path__ + "img/solidworks_books.1676d3c3.jpg";